// src/api/authApi.js
//
// Autenticación del POS Compacto. Habla contra los endpoints /api/pos/*
// del backend. El POS no conoce ni le importa cómo se llame el backend
// ni con qué otros productos comparta ese backend.

import { api } from './apiClient';

export const auth = {
  /**
   * Login del POS. Acepta correo (con @) o teléfono (con o sin +57).
   * Devuelve JWT + info del usuario autenticado.
   */
  login: (usuario, password) =>
    api.post('/api/pos/auth/login', { usuario, password }, { skipAuth: true }),

  /** Devuelve el perfil correspondiente al JWT actual. */
  perfilActual: () => api.get('/api/pos/auth/me'),
};


